import React, {useState} from 'react';
import Icon from '../../components/Icon';

const PlanAdditional = ({levels}) => {
  const [show, setShow] = useState(false);

  return (
    <div>
      {show && levels}
      <button
        onClick={() => setShow(!show)}
        className="btn btn-link btn-sm p-1 position-absolute"
        style={{right: 10, top: 5}}
      >
        <Icon name={show ? 'chevron-up' : 'chevron-down'} />
      </button>
    </div>
  );
};

export default PlanAdditional;
